module.exports = __webpack_public_path__ + "client/img/s_item_15.b9bd3e2f.png";